import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './TogglerInput.module.scss';

export const TogglerInput = ({ checked, className, disabled = false, onChange, 'aria-label': ariaLabel, ...rest }) => {
  const { isDarkMode } = useTheme();

  return (
    <input
      {...rest}
      type="checkbox"
      data-bem="TogglerInput"
      className={cn(CN.togglerInput, { [CN.darkMode]: isDarkMode }, className)}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      aria-label={ariaLabel}
    />
  );
};
